// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"844f82c5","977":"b8e30401"}[chunkId] + ".chunk.js";
};